export const APP_FLAVOR = process.env.REACT_APP_FLAVOR || 'goodlyfe';

export const getAppLogo = () => {
    switch (APP_FLAVOR) {
        case 'communities':
            return '/assets/communities_logo.png';
        case 'yipyap':
            return '/assets/yipyap_logo.png';
        case 'footprint':
            return '/assets/footprint_logo.png';
        default:
            return '/assets/logo.png';
    }
};

export const getAppName = () => {
    switch (APP_FLAVOR) {
        case 'communities':
            return 'Communities';
        case 'yipyap':
            return 'YipYap';
        case 'footprint':
            return 'Footprint';
        default:
            return 'GoodLyfe';
    }
};
